import { __assign } from "tslib";
export var NodePrivacyLevel = {
    IGNORE: 'IGNORE',
    ALLOW: 'ALLOW',
    MASK: 'MASK',
    HIDDEN: 'HIDDEN',
};
export var NodePrivacyLevelInternal = __assign({ 
    // INTERNAL USE: not to be used by the general codebase
    NOT_SET: 'NOT_SET', MASK_FORMS_ONLY: 'MASK_FORMS_ONLY' }, NodePrivacyLevel);
export var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Deprecate via temporariy Alias
export var PRIVACY_CLASS_INPUT_IGNORED = 'dd-privacy-input-ignored'; // DEPRECATED, aliased to mask-forms-only
export var PRIVACY_CLASS_INPUT_MASKED = 'dd-privacy-input-masked'; // DEPRECATED, aliased to mask-forms-only
export var PRIVACY_ATTR_VALUE_INPUT_IGNORED = 'input-ignored'; // DEPRECATED, aliased to mask-forms-only
export var PRIVACY_ATTR_VALUE_INPUT_MASKED = 'input-masked'; // DEPRECATED, aliased to mask-forms-only
// Privacy Attrs
export var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
export var PRIVACY_ATTR_VALUE_MASK = 'mask';
export var PRIVACY_ATTR_VALUE_MASK_FORMS_ONLY = 'mask-forms-only';
export var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
export var PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
export var PRIVACY_CLASS_MASK = 'dd-privacy-mask';
export var PRIVACY_CLASS_MASK_FORMS_ONLY = 'dd-privacy-mask-forms-only';
export var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
export var CENSORED_STRING_MARK = '***';
export var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
export var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-rum/esm/constants.js
// module id = null
// module chunks = 